export default __webpack_public_path__ + "static/media/Arrow-Right.ef05d7c2.svg";